/* ==========================================================================
   The Cat's Pajamas — theme.js
   Collection grid interactions, add-to-cart, and the theme-owned cart drawer
   (replaces the Rebuy Smart Cart — Sept 2026).
   ========================================================================== */

document.addEventListener('click', function (event) {
  if (event.target.matches('.color-toggle')) {
    event.preventDefault();
    let el = event.target;
    let color = el.getAttribute("data-color");
    let id = el.getAttribute("data-product");
    let groups = document.querySelectorAll('.image-group-' + id);
    [].forEach.call(groups, function (el) { el.classList.remove('active'); });
    for (let sib of el.parentElement.children) { sib.classList.remove('active'); }
    el.classList.add('active');
    document.querySelector('.image-group-' + id + '-' + color).classList.add('active');
  }
  if (event.target.matches('.size-toggle')) {
    event.preventDefault();
    let el = event.target;
    let color = el.getAttribute("data-color");
    let id = el.getAttribute("data-product-id");
    let variant_id = el.getAttribute("data-variant-id");
    for (let sib of el.parentElement.children) { sib.classList.remove('active'); }
    el.classList.add('active');
    document.querySelector('#product-select-' + id + '-' + color).value = variant_id;
    document.querySelector('.product-form-' + id + '-' + color).classList.remove('d-none');
  }
}, false);

/* --------------------------------------------------------------------------
   Cart drawer
   -------------------------------------------------------------------------- */
var TCPCart = (function () {
  var GIFT_BOX_VARIANT = 33645965901960;   // $10 Gift Box product — qty mirrors gift-wrapped units
  var NOTE_MAX = 250;
  var drawer, overlay, busy = false, pendingProps = 0;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function getCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }

  function setBusy(state) {
    busy = state;
    $$('#cart-main-ajax, #cart-main').forEach(function (f) { f.classList.toggle('is-busy', state); });
  }

  /* Open / close ---------------------------------------------------------- */
  function open() {
    if (!drawer) return;
    drawer.classList.add('open'); overlay.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('tcp-cart-open');
    var closeBtn = $('.tcp-cart__close', drawer); if (closeBtn) closeBtn.focus({ preventScroll: true });
    loadRecommendations();
  }
  function close() {
    if (!drawer) return;
    drawer.classList.remove('open'); overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('tcp-cart-open');
  }
  function toggle() { drawer.classList.contains('open') ? close() : open(); }

  /* Re-render from the server (single source of truth = Liquid) ------------- */
  function refresh(openAfter) {
    return fetch('/cart?view=ajax', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var markup = doc.body.innerHTML;
        $$('#cart-main-ajax, #cart-main').forEach(function (f) { f.innerHTML = markup; });
        var countEl = doc.querySelector('[data-cart-count]');
        updateCount(countEl ? parseInt(countEl.textContent, 10) : null);
        bindQuantityFields();
        syncCheckoutLock();
        if (openAfter) open();
        loadRecommendations(true);
        document.dispatchEvent(new CustomEvent('tcp:cart:rendered'));
      });
  }
  function updateCount(n) {
    if (n === null || isNaN(n)) return;
    $$('.cart-count').forEach(function (el) { el.textContent = n; el.classList.toggle('d-none', n === 0); });
  }

  /* Gift box sync: qty of Gift Box == sum of gift-wrapped units ------------- */
  function syncGiftBox(cart) {
    var needed = 0, have = 0;
    cart.items.forEach(function (i) {
      if (i.variant_id === GIFT_BOX_VARIANT) { have = i.quantity; return; }
      if (i.properties && i.properties['Gift Wrap'] === 'Yes') needed += i.quantity;
    });
    if (needed === have) return Promise.resolve(cart);
    var updates = {}; updates[GIFT_BOX_VARIANT] = needed;
    return postJSON('/cart/update.js', { updates: updates }).catch(function () { return cart; });
  }

  /* Line helpers ------------------------------------------------------------ */
  function findLine(cart, key) { return cart.items.filter(function (i) { return i.key === key; })[0]; }

  /* Line keys: Shopify builds a line's key from variant + properties, so every properties change gives the line a NEW key.
     Everything still holding the old one (data attributes in the drawer, TCPCart.lastAdded) is re-pointed here;
     otherwise the next save looks the line up by a key that no longer exists and is dropped. */
  var keyAlias = {};
  function currentKey(key) { var hops = 0; while (keyAlias[key] && hops++ < 100) key = keyAlias[key]; return key; }
  function rekey(oldKey, newKey) {
    if (!newKey || newKey === oldKey) return;
    delete keyAlias[newKey];               // a note edited back to earlier text gets an earlier key again
    keyAlias[oldKey] = newKey;
    ['data-key', 'data-gift-for', 'data-gift-toggle', 'data-gift-note', 'data-remove'].forEach(function (attr) {
      $$('[' + attr + '="' + oldKey + '"]').forEach(function (el) { el.setAttribute(attr, newKey); });
    });
    if (lastAdded && lastAdded.key === oldKey) { lastAdded.key = newKey; TCPCart.lastAdded = lastAdded; }
  }
  function sameProps(a, b) {
    a = a || {}; b = b || {};
    var ka = Object.keys(a), kb = Object.keys(b);
    return ka.length === kb.length && ka.every(function (k) { return a[k] === b[k]; });
  }
  function locateLine(after, beforeKeys, line, props) {
    var same = after.items.filter(function (i) { return i.variant_id === line.variant_id; });
    return same.filter(function (i) { return beforeKeys.indexOf(i.key) < 0; })[0]   // the line under its new key
        || same.filter(function (i) { return sameProps(i.properties, props); })[0]    // unchanged, or merged into an identical line
        || null;
  }

  function applyLineProperties(key, mutate) {
    // mutate(props) returns the new properties object for the line
    return getCart().then(function (cart) {
      var line = findLine(cart, key);
      if (!line) throw new Error('Cart line not found: ' + key);
      var next = mutate(Object.assign({}, line.properties || {}));
      var beforeKeys = cart.items.map(function (i) { return i.key; });
      var hasAny = Object.keys(next).length > 0;
      if (hasAny) {
        return postJSON('/cart/change.js', { id: key, properties: next }).then(function (after) {
          if (!after || !after.items) throw new Error((after && after.description) || 'Cart update failed');
          var moved = locateLine(after, beforeKeys, line, next);
          if (moved) rekey(key, moved.key);
          return after;
        });
      }
      // Shopify ignores an empty properties object, so clear by re-adding the variant without properties.
      return postJSON('/cart/change.js', { id: key, quantity: 0 }).then(function () {
        return postJSON('/cart/add.js', { items: [{ id: line.variant_id, quantity: line.quantity }] });
      }).then(function (added) {
        var item = added && added.items ? added.items[0] : added;
        if (item && item.key) rekey(key, item.key);
        return getCart();
      });
    });
  }

  /* One properties change at a time, each resolving the line's current key when it actually runs. */
  var propsQueue = Promise.resolve();
  function setLineProperties(key, mutate) {
    var run = function () { return applyLineProperties(currentKey(key), mutate); };
    pendingProps++; syncCheckoutLock();
    var p = propsQueue.then(run, run);
    propsQueue = p.catch(function () {}).then(function () { pendingProps--; syncCheckoutLock(); });
    return p;
  }

  /* Checkout lock: Redo's Checkout+ buttons sit in a closed shadow root and go to checkout on their own, so their click
     can't be held and replayed like the theme button's. They are switched off for the moment a gift note is unsaved. */
  var lockTimer;
  function notesUnsaved() {
    return pendingProps > 0 || $$('[data-gift-note]').some(function (ta) { return ta._tcpDirty && !ta._tcpFailed; });
  }
  function syncCheckoutLock(release) {
    var lock = !release && notesUnsaved();
    $$('redo-shopify-toggle, [name="checkout"]').forEach(function (el) {
      if (!el.closest('#cart-main-ajax, #cart-main')) return;
      el.style.pointerEvents = lock ? 'none' : ''; el.style.opacity = lock ? '.5' : '';
    });
    clearTimeout(lockTimer);
    if (lock) lockTimer = setTimeout(function () { syncCheckoutLock(true); }, 5000);   // never trap the shopper behind a slow request
  }

  function changeQty(key, qty) {
    if (busy) return; setBusy(true);
    postJSON('/cart/change.js', { id: key, quantity: Math.max(0, qty) })
      .then(getCart).then(syncGiftBox)
      .then(function () { return refresh(false); })
      .catch(console.error).finally(function () { setBusy(false); });
  }

  function toggleGift(key, on) {
    if (busy) return; setBusy(true);
    setLineProperties(key, function (p) {
      if (on) { p['Gift Wrap'] = 'Yes'; if (p['Gift Message'] === undefined) p['Gift Message'] = ''; }
      else { delete p['Gift Wrap']; delete p['Gift Message']; }
      return p;
    })
      .then(getCart).then(syncGiftBox)
      .then(function () { return refresh(false); })
      .then(function () {
        if (on) { var ta = $('[data-gift-note="' + key + '"]'); /* key may change after merge; fall back to last note field */
          if (!ta) { var all = $$('[data-gift-note]'); ta = all[all.length - 1]; }
          if (ta) ta.focus({ preventScroll: true }); }
      })
      .catch(function (e) { console.error(e); return refresh(false); }).finally(function () { setBusy(false); });
  }

  function saveNote(ta) {
    clearTimeout(ta._tcpTimer);
    if (!ta._tcpDirty) return Promise.resolve();
    ta._tcpDirty = false;
    var statusEl = $('[data-note-status]', ta.closest('.tcp-gift'));
    var text = (ta.value || '').slice(0, NOTE_MAX);
    if (statusEl) statusEl.textContent = 'Saving…';
    return setLineProperties(ta.getAttribute('data-gift-note'), function (p) { p['Gift Wrap'] = 'Yes'; p['Gift Message'] = text; return p; })
      .then(function () { if (statusEl) { statusEl.textContent = 'Saved'; setTimeout(function () { statusEl.textContent = ''; }, 1600); } })
      .catch(function (e) { console.error(e); ta._tcpDirty = true; ta._tcpFailed = true; syncCheckoutLock(); if (statusEl) statusEl.textContent = 'Couldn’t save — try again'; });
  }

  /* Save anything still being typed and wait for saves already on their way. */
  function flushNotes() {
    $$('[data-gift-note]').forEach(function (ta) { saveNote(ta); });
    return propsQueue;
  }

  function updateOrderNote(note) {
    return postJSON('/cart/update.js', { note: note });
  }

  /* Recommendations (Shopify native, rendered by sections/cart-recommendations.liquid) */
  var recsLoadedFor = null;
  function loadRecommendations(force) {
    var host = $('#tcp-cart-recs'); if (!host) return;
    var pid = host.getAttribute('data-product-id'); if (!pid) return;
    if (!force && recsLoadedFor === pid && host.innerHTML.trim() !== '') { host.hidden = false; return; }
    recsLoadedFor = pid;
    var base = '/recommendations/products?section_id=cart-recommendations&product_id=' + pid + '&limit=10&intent=';
    fetch(base + 'complementary').then(function (r) { return r.text(); }).then(function (html) {
      var count = countRecs(html);
      if (count >= 2) return html;
      return fetch(base + 'related').then(function (r) { return r.text(); });
    }).then(function (html) {
      var inner = extractSection(html);
      var target = $('#tcp-cart-recs'); if (!target) return;
      target.innerHTML = inner; target.hidden = inner.trim() === '';
    }).catch(function () {});
  }
  function extractSection(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var sec = doc.querySelector('.shopify-section') || doc.body;
    return sec.innerHTML;
  }
  function countRecs(html) { var m = html.match(/data-count="(\d+)"/); return m ? parseInt(m[1], 10) : 0; }

  /* Add to cart (collection quick-add, PDP form) ----------------------------- */
  var lastAdded = null; // { key, variant_id, form } — the line most recently added from this page (PDP gift toggle uses it)
  function addFromForm(form) {
    setBusy(true);
    var fd = new FormData(form);
    return fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin' })
      .then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) { var err = new Error((body && (body.description || body.message)) || 'Could not add to bag'); err.cartResponse = body || {}; throw err; }
          return body;
        });
      })
      .then(function (added) {
        var item = added && added.items ? added.items[0] : added;
        if (item && item.key) { lastAdded = { key: item.key, variant_id: item.variant_id, form: form }; TCPCart.lastAdded = lastAdded; }
        return added;
      })
      .then(getCart).then(syncGiftBox)
      .then(function () { return refresh(true); })
      .catch(function (e) {
        console.error(e);
        /* Shopify rejected the add (e.g. gift card recipient validation) — let the page show it instead of opening an unchanged bag */
        if (e && e.cartResponse) document.dispatchEvent(new CustomEvent('tcp:cart:error', { detail: e.cartResponse }));
      })
      .finally(function () { setBusy(false); });
  }

  /* Gift box on/off (+ note) for a line already in the bag — used by the product page toggle above Add to Bag.
     Changing properties gives the line a new key; setLineProperties tracks that (rekey), including for TCPCart.lastAdded. */
  function setGift(key, on, note) {
    if (busy) return new Promise(function (res) { setTimeout(function () { res(setGift(key, on, note)); }, 400); });
    setBusy(true);
    return setLineProperties(key, function (p) {
      if (on) { p['Gift Wrap'] = 'Yes'; p['Gift Message'] = (note || '').slice(0, NOTE_MAX); }
      else { delete p['Gift Wrap']; delete p['Gift Message']; }
      return p;
    })
      .then(getCart).then(syncGiftBox)
      .then(function () { return refresh(false); })
      .catch(console.error).finally(function () { setBusy(false); });
  }

  /* Events ------------------------------------------------------------------ */
  function debounce(fn, wait) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); }; }

  function bind() {
    drawer = $('#tcp-cart'); overlay = $('.tcp-cart-overlay');
    if (!drawer) return;

    // Item-count badge on the header cart icon (mirrors the count rendered in the drawer header)
    var initial = $('.tcp-cart__header .cart-count');
    var n0 = initial ? parseInt(initial.textContent, 10) || 0 : 0;
    $$('a.nav-icon.cart-toggle').forEach(function (a) {
      if (a.querySelector('.cart-count')) return;
      var s = document.createElement('span'); s.className = 'cart-count' + (n0 === 0 ? ' d-none' : ''); s.textContent = n0; a.appendChild(s);
    });

    // Capture phase: Rebuy's script (until uninstalled) intercepts clicks on the header cart link and stops them bubbling.
    document.addEventListener('click', function (e) {
      var t = e.target;
      // Checkout: hold the click until a gift note still being typed (or mid-save) has reached the cart.
      var co = t.closest('[name="checkout"]');
      if (co && !co._tcpGo) {
        var dirty = $$('[data-gift-note]').some(function (ta) { return ta._tcpDirty; });
        if (dirty || pendingProps > 0) {
          e.preventDefault(); e.stopImmediatePropagation();
          var went = false;
          var go = function () { if (went) return; went = true; co._tcpGo = true; co.click(); co._tcpGo = false; };
          flushNotes().then(go, go);
          setTimeout(go, 4000);            // never trap the shopper behind a slow request
          return;
        }
      }
      if (t.closest('.cart-toggle')) { e.preventDefault(); e.stopPropagation(); toggle(); return; }
      if (t.closest('.tcp-cart-overlay')) { close(); return; }
      var rm = t.closest('[data-remove]'); if (rm) { e.preventDefault(); changeQty(rm.getAttribute('data-remove'), 0); return; }
      var qb = t.closest('[data-qty-change]');
      if (qb) {
        e.preventDefault();
        var wrap = qb.closest('.tcp-qty'); var input = $('[data-qty-input]', wrap);
        var next = parseInt(input.value, 10) + parseInt(qb.getAttribute('data-qty-change'), 10);
        changeQty(wrap.getAttribute('data-key'), next); return;
      }
    }, true);
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-gift-toggle]')) { toggleGift(t.getAttribute('data-gift-toggle'), t.checked); return; }
      if (t.matches('[data-qty-input]')) { var wrap = t.closest('.tcp-qty'); changeQty(wrap.getAttribute('data-key'), parseInt(t.value, 10) || 0); return; }
      if (t.matches('.tcp-note__textarea')) { updateOrderNote(t.value); return; }
    });
    document.addEventListener('input', function (e) {
      var t = e.target;
      if (t.matches('[data-gift-note]')) {
        var count = $('[data-note-count]', t.closest('.tcp-gift')); if (count) count.textContent = t.value.length;
        t._tcpDirty = true; t._tcpFailed = false; syncCheckoutLock();
        clearTimeout(t._tcpTimer);
        t._tcpTimer = setTimeout(function () { saveNote(t); }, 600);
      }
    });
    document.addEventListener('focusout', function (e) {
      var t = e.target;
      if (t.matches && t.matches('[data-gift-note]')) saveNote(t);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('open')) close(); });


    // Open the drawer when ?cart=open (e.g. after a redirect), and reconcile the gift box quietly on load.
    getCart().then(function (cart) {
      var before = JSON.stringify(cart.items.map(function (i) { return [i.key, i.quantity]; }));
      return syncGiftBox(cart).then(function (after) {
        var afterSig = JSON.stringify((after.items || []).map(function (i) { return [i.key, i.quantity]; }));
        if (afterSig !== before) refresh(false);
      });
    }).catch(function () {});
    if (/[?&]cart=open/.test(location.search)) open();
  }

  return { open: open, close: close, toggle: toggle, refresh: refresh, addFromForm: addFromForm, setGift: setGift, bind: bind };
})();


/* Back-compat shims for older inline scripts */
function refreshCart(toggleCartDrawer) { return TCPCart.refresh(toggleCartDrawer !== false); }
function toggleCartLoader() {}
function updateCart(cart) { /* form-based updates are now handled per control by TCPCart */ }

function bindQuantityFields() {
  Array.prototype.slice.call(document.querySelectorAll('.quantity-container')).map(function (container) {
    return {
      input: container.querySelector('.quantity-amount'),
      decrease: container.querySelector('.quantity-decrease'),
      increase: container.querySelector('.quantity-increase'),
      get value() { return parseInt(this.input.value); },
      set value(v) { this.input.value = v; }
    };
  }).forEach(function (item) {
    if (!item.input || !item.decrease || !item.increase) return;
    item.decrease.onclick = function () { item.value = Math.max(1, item.value - 1); };
    item.increase.onclick = function () { item.value += 1; };
  });
}

function bindAddToCartForms() {
  let forms = document.querySelectorAll('form[action$="/cart/add"]');
  [].forEach.call(forms, function (form) {
    if (form && !form.dataset.tcpBound) {
      form.dataset.tcpBound = '1';
      form.addEventListener("submit", addProductToCart);
    }
  });
}

function addProductToCart(e) {
  e.preventDefault();
  TCPCart.addFromForm(e.target);
}

function debounce(func, wait, immediate) {
  var timeout;
  return function executedFunction() {
    var context = this;
    var args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

function predictive_search() {
  var input = document.querySelector('#q');
  const predictiveSearchSection = document.querySelector('#predictive-results');
  if (!input || !predictiveSearchSection) return;
  var requestResponse;
  input.addEventListener('input', debounce((event) => {
    predictiveSearchSection.style.display = 'block';
    predictiveSearchSection.innerHTML = '<div class="mx-auto my-3 text-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>';
    var search_term = input.value;
    if (input.value != '') {
      fetch('/search/suggest?q=' + search_term + '&resources[type]=product&resources[limit]=10&section_id=site-predictive-search').then((response) => {
        requestResponse = response;
        return response.text();
      })
        .then((text) => {
          if (!requestResponse.ok) {
            console.error(requestResponse.status + ': ' + text);
          }
          const resultsMarkup = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-site-predictive-search').innerHTML;
          predictiveSearchSection.innerHTML = resultsMarkup;
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      predictiveSearchSection.style.display = 'none';
    }
  }, 500));
};

/* Announcement mirror: copies the header announcement bar text into every [data-announce-mirror]
   (product page under Add to Bag, cart footer) so it never has to be edited in two places. */
function mirrorAnnouncement() {
  var texts = Array.prototype.slice.call(document.querySelectorAll('.announcements .carousel-item'))
    .map(function (i) { return i.textContent.replace(/\s+/g, ' ').trim(); }).filter(Boolean);
  if (!texts.length) return;
  var text = texts.join(' · ');
  Array.prototype.slice.call(document.querySelectorAll('[data-announce-mirror]')).forEach(function (el) { el.textContent = text; el.hidden = false; });
}
document.addEventListener('tcp:cart:rendered', mirrorAnnouncement);

window.addEventListener("load", function () {
  bindQuantityFields();
  bindAddToCartForms();
  predictive_search();
  TCPCart.bind();
  mirrorAnnouncement();
  if (!window.matchMedia("(pointer: coarse)").matches) {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl, { html: true });
    });
  }
});

function header() {
  var header = document.querySelector(".header");
  if (!header) return;
  if (header.getBoundingClientRect().top <= 40) {
    header.classList.add("scrolled");
  } else {
    header.classList.remove("scrolled");
  }
  var toggler = document.querySelector(".navbar-toggler");
  if (toggler && !toggler.dataset.bound) {
    toggler.dataset.bound = '1';
    toggler.addEventListener('click', function (event) { header.classList.add("scrolled"); return; }, false);
  }
}
window.addEventListener("scroll", header);

function formatMoney(cents) {
  return (cents / 100).toLocaleString("en-US", { style: "currency", currency: "USD" });
}
function handleize(str) {
  str = str.toLowerCase();
  var toReplace = ['"', "'", "\\", "(", ")", "[", "]", "$"];
  for (var i = 0; i < toReplace.length; ++i) {
    str = str.replace(toReplace[i], "");
  }
  str = str.replace(/\W+/g, "-");
  if (str.charAt(str.length - 1) == "-") {
    str = str.replace(/-+\z/, "");
  }
  if (str.charAt(0) == "-") {
    str = str.replace(/\A-+/, "");
  }
  return str
};

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
